var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C51BE4FA-BC61-4756-84AF-73E002D522E4@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AMP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AMP_v1",
    transform: "translate(-751.000000, -3676.000000)",
    fill: "#6F7B91",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(751.000000, 3676.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.16341688,0 0,7.16341688 0,16 C0,24.8365831 7.16341688,32 16,32 C24.8365831,32 32,24.8365831 32,16 C32,7.16341688 24.8365831,0 16,0 Z M22.1040614,8.14813299 L19.8910691,8.14911509 C18.1557033,8.14911509 17.8201535,8.97374936 17.8201535,10.1836931 L17.8201535,12.8517238 L21.9583836,12.8517238 L21.9564194,17.0305473 L17.8204808,17.0305473 L17.8204808,27.7543939 L13.5041637,27.7543939 L13.5041637,17.0305473 L9.89593862,17.0305473 L9.89593862,12.8517238 L13.5041637,12.8517238 L13.5041637,9.76990281 C13.5041637,6.19343223 15.6893299,4.24560614 18.879509,4.24560614 L22.1043887,4.25051662 L22.1043887,8.14813299 L22.1040614,8.14813299 Z",
    id: "Shape"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGrey);
export default ForwardRef;